export enum FormKind {
  BUDGET_FORM = 1,
  ECONOMY_FORM = 2
}
